import { createFileRoute, type ErrorComponentProps } from "@tanstack/react-router";
import { CmsRouteView } from "@/components/cms/CmsRouteView";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/returns")({
  head: () => ({ meta: [
    { title: "Return Policy — CB16 Atelier" },
    { name: "description", content: "Return, refund and exchange terms for CB16 fragrances." },
    { property: "og:title", content: "CB16 Return Policy" },
    { property: "og:description", content: "Return, refund and exchange terms for CB16 fragrances." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { property: "og:url", content: canonicalUrl("/returns") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/returns") }] }),
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("returns")),
  errorComponent: ({ error }: ErrorComponentProps) => (
    <div role="alert" className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">
      {error instanceof Error ? error.message : "Something went wrong."}
    </div>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">Page not found.</div>
  ),
  component: () => <CmsRouteView slug="returns" fallbackTitle="Return Policy" />,
});